// DO NOT EDIT -- generated from fs/services/eraser/log.proto

import * as protobuf from '../../../google/protobuf';

export interface DeletionEvent {
  /** Log event ID. */
  id: string;
  /** Timestamp of the log event. */
  timestamp: protobuf.timestamp | null;
  /** The org in which the event occurred. */
  orgId: string;
  /** What the event was (Segment Sessions, Single Sessions, Individual, etc). */
  eventType: DeletionEventType;
  /** Timestamp of the earliest event that was deleted. */
  earliestEventTime: protobuf.timestamp | null;
  /** Timestamp of the latest event that was deleted. */
  latestEventTime: protobuf.timestamp | null;
  /** Number of sessions deleted. */
  sessions: protobuf.int64;
  /** Number of events deleted. */
  events: protobuf.int64;
  /** Number of individuals deleted. */
  individuals: protobuf.int64;
  /** Number of users deleted. */
  users: protobuf.int64;
}

export enum DeletionEventType {
  EVENT_TYPE_INVALID = 0,
  /** Delete all sessions that match the segment criteria. */
  SEGMENT_SESSIONS = 1,
  /** Delete all individuals that match the segment criteria. */
  SEGMENT_INDV = 2
}
